import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  useLazyGetShopItemDetailQuery,
  useLazyGetPropertyDetailQuery,
  useLazyGetSellVehicleByIdQuery,
  useLazyGetTransportVehicleByIdQuery
} from "../features/shop/shopApiSlice";

export const useUserItemShopState = () => {
  const location = useLocation();

  const [triggerGetShopItemDetail] = useLazyGetShopItemDetailQuery();
  const [triggerGetPropertyDetail] = useLazyGetPropertyDetailQuery();
  const [triggerGetSellVehicleDetail] = useLazyGetSellVehicleByIdQuery();
  const [triggerGetTransportVehicleDetail] = useLazyGetTransportVehicleByIdQuery();

  const [showshare, setShowshare] = useState(false);
  const [showmodal, setShowmodal] = useState(0);
  const [shareurl, setShareurl] = useState("");
  const [show, setShow] = useState(false);
  const [shopview, setShopview] = useState();
  const [showcategory, setShowcategory] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isOpenone, SetisOpenone] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const handleClosetwo = () => setShow(0);
  const handleClosemodal = () => {
    setShowModal(false);
    setShowmodal(0);
  };
  
  const handleShowModal = () => {
    setShowModal(true);
    setShow(0);
  };
  
  const handleCloseshare = () => {
    setShowshare(0);
  };
  
  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
    setShowmodal(0);
  };
  
  const handleFocus = () => setShowDropdown(true);
  const handleBlur = () => setTimeout(() => setShowDropdown(false), 100);

  const UserShopView = async (e) => {
    setShopview(null);
    try {
      const path = location.pathname.toLowerCase();
      if (path.includes("/buy-single-property") || path.includes("/user-peronal-property") || path.includes("/user-bussines-property")) {
        const res = await triggerGetPropertyDetail(e).unwrap();
        setShopview(res?.data?.Property);
      } else if (path.includes("/byvehicleuserprofile") || path.includes("/byvehicle-userprofile")) {
        const res = await triggerGetSellVehicleDetail(e).unwrap();
        setShopview(res?.data?.SellVehicle || res?.data?.sellvehicle || res?.data?.sellVehicle);
      } else if (path.includes("/buying-transport")) {
        const res = await triggerGetTransportVehicleDetail(e).unwrap();
        setShopview(res?.data?.TransportVehicle || res?.data?.transportVehicle || res?.data?.transportvehicle);
      } else {
        const res = await triggerGetShopItemDetail(e).unwrap();
        setShopview(res?.data?.ShopItem);
      }
    } catch (err) {
      console.log("error fetching shop view detail", err);
    }
  };

  useEffect(() => {
    if (show === true) {
      handleImgone();
      handleImg();
    }
  }, [shopview, show]);

  const handleImgone = () => {
    const imgs = document.querySelectorAll(".image-gallery-image");
    imgs.forEach((element) => {
      element.setAttribute("crossorigin", "anonymous");
    });
  };

  const handleImg = () => {
    const thumimgs = document.querySelectorAll(".image-gallery-thumbnail-image");
    thumimgs.forEach((element) => {
      element?.setAttribute("crossorigin", "anonymous");
    });
  };

  return {
    showshare,
    showmodal,
    shareurl,
    show,
    shopview,
    showcategory,
    showModal,
    isOpenone,
    activeTab,
    showDropdown,
    setShowshare,
    setShowmodal,
    setShareurl,
    setShow,
    setShopview,
    setShowcategory,
    setShowModal,
    SetisOpenone,
    setActiveTab,
    setShowDropdown,
    handleClosetwo,
    handleClosemodal,
    handleShowModal,
    handleCloseshare,
    handleShowshare,
    handleFocus,
    handleBlur,
    UserShopView
  };
};
